import { createAsyncThunk } from '@reduxjs/toolkit';

import { IRelationUsersResponse } from "../types";
import { snackbarAction } from "../../errors/SnackbarSlice";

export const fetchRelationUsers = createAsyncThunk<IRelationUsersResponse, void, { rejectValue: string }>(
    "relationUsers/fetchRelationUsers",
    // @ts-ignore
    async (arg: void, thunkAPI) => {
        const {extra, rejectWithValue, dispatch} = thunkAPI;

        try {
            // @ts-ignore
            const response= await extra.api.get<IRelationUsersResponse>(
                'relationship/friend',
            );

            if (!response.data.success) {
                return rejectWithValue('error')
            }

            return response.data;
        } catch (error: any) {
            dispatch(snackbarAction.addError('INTERNAL_ERROR'));
            return rejectWithValue(error.response?.data?.message || 'Failed to fetch friends');
        }
    }
);
